'use client';

import { ButtonDropdown } from '@petsmart-ui/sparky';

import { useOptimizely } from '@libs/common-next';

import { closeButtonDropdown } from '@/utils/closeButtonDropdown';

import OptexDeliveryFilterContent from './OptexDeliveryFilterContent';
import { getOptexButtonText, OPTEX_DEFAULT_TITLE } from './optexDeliveryFilterConstants';
import { useOptexSelectedDeliveryMethod } from './useOptexSelectedDeliveryMethod';

import './OptexDeliveryFilterExperiment.scss';

type OptexDeliveryFilterProps = Readonly<{
    behavior?: 'responsive';
    pageId: string;
    openStoreModal: () => void;
    clearShop: () => void;
    handleIsStoreFilterApplied: (isApplied: boolean) => void;
}>;

export default function OptexDeliveryFilter({
    behavior,
    pageId,
    openStoreModal,
    clearShop,
    handleIsStoreFilterApplied,
}: OptexDeliveryFilterProps) {
    const { context } = useOptimizely();
    const selectedMethod = useOptexSelectedDeliveryMethod();
    const buttonText = getOptexButtonText(selectedMethod);

    const handleOptexFilterEngagement = () => {
        context?.trackEvent?.('filter_engagement');
    };

    return (
        <ButtonDropdown
            behavior={behavior}
            variant="toolbar"
            buttonText={buttonText}
            ariaLabelledBy={buttonText}
            drawerTitle={OPTEX_DEFAULT_TITLE}
            onStateChange={(isActive: boolean) => {
                if (isActive) {
                    handleOptexFilterEngagement();
                }
            }}
            data-testid="optex_delivery_filter"
        >
            <div className="filter-drawer-container">
                <OptexDeliveryFilterContent
                    pageId={pageId}
                    openStoreModal={openStoreModal}
                    clearShop={clearShop}
                    handleIsStoreFilterApplied={handleIsStoreFilterApplied}
                    onViewResults={closeButtonDropdown}
                    showActions
                />
            </div>
        </ButtonDropdown>
    );
}
